import { useMemo } from 'react';
import { useCategories } from '@/hooks/queries/useCategories';
import { useCategoryRules } from '@/hooks/queries/useCategoryRules';

/**
 * Refs with at least one merchant rule — gates the kebab's "Regras desta categoria"
 * item. Rules target LEAVES (the Categorizar picker offers them), so each ref also
 * marks its taxonomy root. Shared by the Categorias page and the transações
 * category drawer, which expose the same kebab controls.
 */
export function useRuleRefs(): ReadonlySet<string> {
  const { data: pickerCategories } = useCategories(true);
  const { data: allRules } = useCategoryRules();

  return useMemo(() => {
    const rootOf = new Map<string, string>();
    for (const parent of pickerCategories ?? []) {
      for (const child of parent.children) rootOf.set(child.id, parent.id);
    }
    const refs = new Set<string>();
    for (const rule of allRules ?? []) {
      refs.add(rule.categoryRef);
      const root = rootOf.get(rule.categoryRef);
      if (root) refs.add(root);
    }
    return refs;
  }, [allRules, pickerCategories]);
}
